import DeclineForm from './DeclineForm';

export default DeclineForm;
